import { RouteRecordRaw } from 'vue-router';

const ReportsRoutes: RouteRecordRaw[] = [
  {
    path: '/reports',
    name: 'Reports',
    component: () => import('@/views/Page/Reports/Reports.vue'),
    meta: {
      title: 'Reports',
      requiresAuth: true
    }
  },
  {
    path: '/reports/:id',
    name: 'ReportDetail',
    component: () => import('@/views/Page/Reports/Reports.vue'),
    meta: {
      title: 'Report Detail',
      requiresAuth: true
    }
  }
];

export default ReportsRoutes;
